export default function ChatgptCoding() {
  return <h2>Chatgpt Coding</h2>;
}
